module.exports = __webpack_public_path__ + "img/photo-19.253f414d.jpg";